import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './styles/globals.css';
import './styles/fonts.css';
import { ThemeProvider } from '@/components/theme/theme-provider';
import { onUnauthorized } from './api/server';
import { router } from './router';

// A call answered "not signed in" (session expired, admin removed) while
// a screen is open: go to the login page.
onUnauthorized(() => {
  if (router.state.location.pathname !== '/admin/login') void router.navigate('/admin/login');
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>,
);
